import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { enterprisesBackend } from './enterprises.backend';
import { enterprisesReducer } from './enterprises.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('enterprises', enterprisesReducer),
    BackendModule.forFeature('enterprises', enterprisesBackend),
  ],
})
export class DatastoreEnterprisesModule {}
